import { NewsCategory } from "admin/type/type";
import { NewsProps } from "types/news";
import { ApiNews } from "lib/latticeApi";

/** API news → 기존 NewsProps 변환 */
export function toNewsProps(row: ApiNews): NewsProps {
  return {
    hpNewsId: row.id as unknown as number,
    openDate: row.published_date,
    linkUrl: row.article_url,
    thumbNail: row.thumbnail_url ?? undefined,
    title: row.title ?? undefined,
    category:
      row.category === "portfolio"
        ? NewsCategory.BLUE_FAMILY
        : NewsCategory.BLUEPOINT,
    description: row.content ?? undefined,
    isActive: true,
    createdAt: undefined,
    hpPortfolio: row.startup_name
      ? {
          portfolioId: row.id as unknown as number,
          companyName: row.startup_name,
        }
      : undefined,
  };
}
